import { AxiosError } from 'axios';
import { HTTPStatusCodes } from '../enums';

export const isMaintenanceMode = (error: AxiosError) =>
  error?.response?.status === HTTPStatusCodes.SERVICE_UNAVAILABLE &&
  (error?.response?.data as Record<string, any>)?.message === 'maintenance';
